export default __webpack_public_path__ + "static/media/tabMine.200b9f2f.svg";